import React, { createContext, useContext, useState, useEffect } from "react";
const PreferenceContext = createContext();

export const PreferenceProvider = ({ children }) => {
  const [preferences, setPreferences] = useState(() => {
    const saved = localStorage.getItem("preferences");
    if (saved) {
      return JSON.parse(saved);
    } else {
      return {
        isCardView: true,
        collapsedHeaders: {},
      };
    }
  });

  useEffect(() => {
    localStorage.setItem("preferences", JSON.stringify(preferences));
  }, [preferences]);

  return (
    <PreferenceContext.Provider value={{ preferences, setPreferences }}>
      {children}
    </PreferenceContext.Provider>
  );
};

export const usePreference = () => useContext(PreferenceContext);
